module.exports = __webpack_public_path__ + "static/media/old-user.65a4cfd2.png";